import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { BackButton } from "../../../../components";
import {
  getDumpster,
  getDumpsterLocationHistory,
  resetDumpsterDetails,
} from "../../dumpstersSlice";
import { getVehicles } from "../../../Vehicles/vehiclesSlice";
import { DumpsterDetailsCard } from "./DumpsterDetailsCard";
import { DumpsterHistoryCard } from "./DumpsterHistoryCard";

import "./DumpsterDetails.scss";

export function DumpsterDetails() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const dumpsterId = params.id;

  const getDumpsterAPI = useAppSelector((state) => state.dumpsters.getDumpster);
  const dumpster = useAppSelector((state) => state.dumpsters.selectedDumpster);

  React.useEffect(() => {
    if (!dumpsterId) return;
    dispatch(getDumpster(dumpsterId));
    dispatch(getDumpsterLocationHistory(dumpsterId));
    dispatch(getVehicles({}));

    return () => {
      dispatch(resetDumpsterDetails());
    };
  }, [dumpsterId, dispatch]);

  const onBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="dumpster-details-component">
      <div className="back-button-container">
        <BackButton onClick={onBackButtonClick} />
      </div>

      {getDumpsterAPI.loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <>
          {dumpster && <DumpsterDetailsCard dumpster={dumpster} />}
          {dumpster && <DumpsterHistoryCard />}
        </>
      )}
    </div>
  );
}
